import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {CommonService} from '../../../services/common.service';
import {JurisdictionService} from '../../jurisdiction.service';
import {FiringSystemDataObject} from '../../facilities-form/facilities-form.domain';
import {FacilitiesFormService} from '../../facilities-form/facilities-form.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-information-on-meter-installation',
  templateUrl: './information-on-meter-installation.component.html',
  styleUrls: ['./information-on-meter-installation.component.scss']
})
export class InformationOnMeterInstallationComponent implements OnInit {
  @Input() firingSystemData: FiringSystemDataObject;
  @Input() isReadOnly: boolean = false;

  meterInstallationFG: FormGroup;
  formSubscription: Subscription;

  constructor(private fb: FormBuilder,
              private commonService: CommonService,
              private jurisdictionService: JurisdictionService,
              private facilitiesFormService: FacilitiesFormService,
  ) {
  }

  ngOnInit(): void {
    this.prepareFormGroup();
    this.facilitiesFormService.registerForComponentFormUpdate.next({
      component: 'meterInstallation',
      formData: this.meterInstallationFG,
    });
    this.meterInstallationFG.valueChanges.subscribe(x => {
      this.jurisdictionService.setMeterInstallation(x.meterInstallation);
    });
    this.jurisdictionService.setMeterInstallation(this.firingSystemData?.meterInstallation || '1');
    this.facilitiesFormService.registerForActionOnFormSubmit.subscribe(
      (value: boolean) => {
        if (value) {
          this.resetData();
        }
      });
  }

  prepareFormGroup(): void {
    this.meterInstallationFG = this.fb.group({
      meterInstallation: [{value: this.firingSystemData?.meterInstallation || '1', disabled: this.isReadOnly}]
    });
    this.formSubscription = this.meterInstallationFG.valueChanges.subscribe((x) => {
      this.facilitiesFormService.registerForComponentFormUpdate.next({
        component: 'meterInstallation',
        formData: this.meterInstallationFG,
      });
    });
  }

  private resetData(): void {
    this.formSubscription.unsubscribe();
    this.prepareFormGroup();
  }
}
